export const ONEMAP_API_URL = "https://www.onemap.gov.sg/api";
export const ONEMAP_SEARCH_ADDRESS_API_URL = `${ONEMAP_API_URL}/common/elastic/search`;
